"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { MessageCircle } from "lucide-react";
export default function TalkToEMillenniumSpecialist() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="fale-com-um-especialista-e-millennium" className="relative py-20 bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592892/img/emillennium_bottom_cta_bg.png)]">
      {}
      <div className="absolute inset-0 bg-background/80 backdrop-blur-md" />

      <div ref={ref} className={`relative z-10 mx-auto max-w-7xl px-4 sm:px-8 text-center transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <p className="text-base font-normal text-foreground/90 mb-4">
          Não perca tempo com soluções que limitam o crescimento do seu atacado ou e-commerce.
        </p>
        
        <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-10 max-w-3xl mx-auto leading-tight">
          Pronto para escalar sua operação com o e-Millennium?
        </h2>

        <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-foreground text-lg font-semibold px-8 py-7 rounded-[10px] shadow-lg transition-transform hover:scale-105">
          <Link to="https://api.whatsapp.com/send?phone=5527992826653&text=Bem%20vindo%20a%20Franquia%20Linx%20Vila%20Velha.">
            <MessageCircle className="mr-2 h-6 w-6" />
            Falar com um Especialista no WhatsApp
          </Link>
        </Button>
      </div>
    </section>;
}